import { NewMap } from '@synergy/maps';
import { Flex } from "antd";
import { useState } from "react";
import styled from "styled-components";
import { REACT_APP_MAPS_API_KEY } from "../../../../utils/config/configs";
import Spinner from '../../Atomics/Spinner';

//#region  Styled Components
//Where we define the styles, CSS and other aspects for the page components
const ErrorMessage = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    font-size: 16px;
    color: black;
    font-weight: bold;
`;

const MapWrapper = styled.div`
    height: ${props => (props.$marginTop ? 'calc(100% - ' + props.$marginTop + ')' : props.$height)};
    margin-top: ${props => (props.$marginTop ? props.$marginTop : '0')};
    padding: 0;
    width: -webkit-fill-available;
`;

const test = [
    {
        "id": "1fd56ede-9140-47ec-8db9-8b129aaf693d",
        "name": "VGVsZWZvbmUgZGEgcmVjZcOnw6NvIGF2YXJpYWRv",
        "label": "Incident",
        "address": null,
        "latitude": "41.15504",
        "longitude": "-8.63016",
        "numberOfFloors": null,
        "subtype": null,
        "capacity": null,
        "tenant": "TOP/DELOITTE/PT/PORTO/BOM SUCESSO",
        "active": "1",
        "location": null,
        "family": "Buildings.Commercial",
        "status": "Registered",
        "priority": "5 - Low",
        "urgency": "5 - When Possible",
        "class": "Office"
    },
    {
        "id": "0d7c0e23-2505-4de1-9f67-c3bac448947b",
        "name": "UG9ydGEgZGUgZW50cmFkYSBkYW5pZmljYWRh",
        "label": "Incident",
        "address": null,
        "latitude": "41.15504",
        "longitude": "-8.63016",
        "numberOfFloors": null,
        "subtype": null,
        "capacity": null,
        "tenant": "TOP/DELOITTE/PT/PORTO/BOM SUCESSO",
        "active": "1",
        "location": null,
        "family": "Buildings.Commercial",
        "status": "Registered",
        "priority": "5 - Low",
        "urgency": "5 - When Possible",
        "class": "Office"
    },
    {
        "id": "077f3265-54ff-4987-9fda-f7763d2095b3",
        "name": "RWxldmFkb3IgYXZhcmlhZG8=",
        "label": "Incident",
        "address": null,
        "latitude": "41.15795",
        "longitude": "-8.64297",
        "numberOfFloors": null,
        "subtype": null,
        "capacity": null,
        "tenant": "TOP/DELOITTE/PT/PORTO/BESSA LEITE",
        "active": "1",
        "location": null,
        "family": "Buildings.Commercial",
        "status": "Registered",
        "priority": "5 - Low",
        "urgency": "5 - When Possible",
        "class": "Office"
    }
]
//#endregion

// Define the SimpleMapComponent function component
export const SimpleMapComponent = ({ pois, height }) => {
    const [mapData, setMapData] = useState(null);
    const [mapIsLoaded, setMapIsLoaded] = useState(false);

    setTimeout(() => {
        setMapIsLoaded(true);
    }, [1000]);

    // Render SimpleMapComponent
    return (
        <MapWrapper $height={height}>
            {mapIsLoaded ? (
                <NewMap
                    apiKey={REACT_APP_MAPS_API_KEY}
                    configurations={defaultMapConfigurations}
                    pois={test}
                // onMarkerClick={(id, event) => handleMarkerClick(id, event)}
                // onDoubleClickFucntion={(coordinates) => { setIsRigthClickModalOpen(true); setRigthClickCoordinates(coordinates) }}
                // onClusterClick={(cluster) => { setSelectedCluster(cluster); showDrawer(); console.log(cluster) }}
                />
                // <NewMap configurations={mapConfigurationsData} pois={test} mapApiKey={REACT_APP_MAPS_API_KEY}/>

            ) : (
                <Flex align="center" justify="center" className="full-h">
                    <Spinner stroke="green-4" />
                </Flex>
            )}
        </MapWrapper>
    );
}

const defaultMapConfigurations = {
    "heading": 0,
    "hide": [
        "attraction",
        "sports_complex",
        "place_of_worship",
        "business",
        "government",
        "medical",
        "park",
        "school"
    ],
    "mapId": "15fb961c1d0a757",
    "showGTFSRealTime": false,
    "showPOIS": true,
    "showTraffic": false,
    "showTransit": false,
    "showPolygon": false,
    "showEvents": false,
    "styles": "default",
    "tilt": 0,
    "zoom": 12,
    "hrefLink": "/home/register/registerDetail/",
    "poiType": "pois-color-by-family",
    "showLegend": false,
    "legendArray": [],
    "legendDetail": true,
    "hideEventsInfo": false,
    "circleRadius": null,
    "lat": 41.15727108541772,
    "lng": -8.62729341119487
}